import Vue from 'vue';
import { Location, RouteConfig } from 'vue-router';
import { fetchABTest } from '@/shared/abtest';

const CONTRAST = 2;

/**
 * 会员卡ABTest转发  1-实验组 Plan A  2-对照组 Plan B
 */
function createVipComponent(planAPath: string, planBPath: string) {
  return Vue.extend({
    async created() {
      const vipVersion = await fetchABTest<1 | 2>('vipVersion', 1);

      const target = {
        ...this.$route,
        path: planAPath,
      } as Location;

      if (vipVersion === CONTRAST) {
        target.path = planBPath;
      }
      this.$router.replace(target);
    },
    render(h) {
      return h();
    },
  });
}

export default [
  /**
   * 专享权益-未购
   */
  {
    path: '/vip',
    meta: {
      customNavBar: true,
      excludeLogin: true,
      excludeTracking: true,
    },
    component: createVipComponent('/vip/plan-a', '/vip/plan-b'),
  },
  {
    path: '/vip/plan-a',
    meta: {
      title: '超级会员',
      background: '#f6f7fb',
      customNavBar: true,
      excludeLogin: true,
    },
    component: () => import('@/views/vip/plan-a.vue'),
  },
  {
    path: '/vip/plan-b',
    meta: {
      title: '超级会员',
      background: '#fff',
      customNavBar: true,
      excludeLogin: true,
    },
    component: () => import('@/views/vip/plan-b.vue'),
  },
  /**
   * 专享权益-已购
   */
  {
    path: '/vip/bought',
    meta: {
      title: '我的会员',
      customNavBar: true,
      background: '#F8F9FF',
    },
    component: () => import('@/views/vip/bought.vue'),
  },
  /**
   * 专享权益-已购
   * 应付审核
   */
  {
    path: '/vip/review',
    meta: {
      excludeLogin: true,
      title: '专享权益',
      background: '#f6f7fb',
      customNavBar: true,
    },
    component: () => import('@/views/vip/review/index.vue'),
  },
  /**
   * 专享权益-已购
   * 应付审核
   */
  {
    path: '/vip/review/bought',
    meta: {
      excludeLogin: true,
      title: '专享权益',
      background: '#f6f7fb',
      customNavBar: true,
    },
    component: () => import('@/views/vip/review/bought.vue'),
  },
  /**
   * 我的金币
   */
  {
    path: '/vip/exchange',
    meta: {
      excludeLogin: true,
      title: '我的金币',
      background: '#F5F6FA',
      customNavBar: true,
    },
    component: () => import('@/views/vip/exchange/index.vue'),
  },
  /**
   * 金币兑换记录
   */
  {
    path: '/vip/exchange/record',
    meta: {
      excludeLogin: true,
      title: '兑换记录',
      background: '#F5F6FA',
    },
    component: () => import('@/views/vip/exchange/record.vue'),
  },
] as RouteConfig[];
